function init(){
    let buttonRedirect = document.querySelector('.btn-login-account');
    // Login popup (login-popup.js) handles the button when rendered
    if(!buttonRedirect || document.querySelector('.login-popup-overlay')) {
        return;
    }
    buttonRedirect.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Redirecting to login page');
        document.cookie = "redirect_to=" + encodeURIComponent(window.location.href) + "; path=/";
        window.location.href = buttonRedirect.getAttribute('href');
    });
}

export default { init };